<template>
  <statistiche-agyo />
</template>

<script>
import StatisticheAgyo from '@/components/ask/pages/tesoreria/StatisticheAgyo.vue'

export default {
  name: 'PageTesoreriaStatisticheAgyo',

  components:{
    StatisticheAgyo
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
